import { render, staticRenderFns } from "./PasswordChange.vue?vue&type=template&id=3c0a2043&scoped=true"
import script from "./PasswordChange.vue?vue&type=script&lang=js"
export * from "./PasswordChange.vue?vue&type=script&lang=js"
import style0 from "./PasswordChange.vue?vue&type=style&index=0&id=3c0a2043&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0a2043",
  null
  
)

export default component.exports